import { Injectable } from '@angular/core';
import { URLS } from './urls';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { DataModelsService } from './data-models.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HttpGetService {
  headers: any;
  constructor(private http: HttpClient, private addressOBJ: DataModelsService) {
    this.headers = new HttpHeaders();
    this.headers.set('Access-Control-Allow-Origin', '*');
    this.headers.set('Content-Type', 'application/json');
  }


  getMenuData(tenantId, branchId, profitCenterId, menuByProfitCenter, bycell) {
    let url = '';

    if (bycell) {
      // tenantId = 2639;
      url = `${URLS.GET_BYCELL_MENU}?`;
    } else if (menuByProfitCenter) {
      url = URLS.GET_MENU_BY_PROFITCENTER + `?profitCenterId=${profitCenterId}&`;
    } else {
      url = `${URLS.GET_MENU}?`;
    }

    const queryParams = `tenantId=${tenantId}&branchId=${branchId}`;
    return this.http.get(url + queryParams);
  }

  updateMenu(tenantId, branchid, profitCenterId) {
    if (profitCenterId) {
      return this.http.get(`https://ecomflows3.zaravya.com/clearCache?tenantId=${tenantId}&branchId=${branchid}&profitCenterId=${profitCenterId}`);
    } else {
      return this.http.get(`https://ecomflows3.zaravya.com/clearCache?tenantId=${tenantId}&branchId=${branchid}`);
    }

  }

  getWeraMenuData(tenantId, branchid, profitCenterId, profitCenterName, packageChange) {
    // return this.http.get(URLS.GET_WERA_MENU_BY_PROFITCENTER + `?tenantId=${tenantId}&branchId=${branchid}&profitCenterId=${profitCenterId}`);
    // return this.http.get("http://localhost:4300/getMenuOptions" + `?tenantId=${tenantId}&branchId=${branchid}&profitCenterName=${profitCenterName}`);
    return this.http.get(environment.serverUrl + `getMenuOptions?tenantId=${tenantId}&branchId=${branchid}&profitCenterName=${profitCenterName}&packageCharge=${packageChange}`, { headers: this.headers });


  }

  login(username, password) {
    const url = `https://app.eposfx.com/epos/interface/mobileLogin?username=${username}&password=${password}`;
    // console.log("Login URL:::", url);
    return this.http.get(url);
  }

  webLogin(username, password) {
    const url = `https://owgmjldkukvkhqlfihfc.supabase.co/functions/v1/getMobileLogin?username=${username}&password=${password}`;
    return this.http.get(url);
  }

  getWebRestaurantDetails(tenant_id, resource, type) {
    const headers = new HttpHeaders()
      .set('accept', 'application/json, text/plain, */*')
      .set('authorization', 'Bearer nuigh&YT7Q3RBUyt63#bIGgvadi')
      .set('content-type', 'application/json');
    
    const body = {
      tenant_id: tenant_id,
      resource: resource,
      type: type
    };
    
    return this.http.post('https://owgmjldkukvkhqlfihfc.supabase.co/functions/v1/getRestaurantDetails', body, { headers: headers });
  }

  createMarchantData(body) {

    //return this.http.post("http://localhost:4300/registerMerchant", body, { headers: this.headers });
    return this.http.post(environment.serverUrl + "registerMerchant", body, { headers: this.headers });

  }

  createMarchant(body) {
    //return this.http.post("http://localhost:4300/createMerchant", body, { headers: this.headers });
    return this.http.post(environment.serverUrl + "createMerchant", body, { headers: this.headers });
  }

  getMarchantsData() {

    //return this.http.get("http://localhost:4300/getMerchants", { headers: this.headers });
    return this.http.get(environment.serverUrl + "getMerchants", { headers: this.headers });

  }

  uploadMenu(body) {

    //return this.http.post("http://localhost:4300/uploadMenu", body, { headers: this.headers });
    return this.http.post(environment.serverUrl + "uploadMenu", body, { headers: this.headers });
  }
  //9cfb73cd8082b10b6d645b8539d5f490

  getLatestOrders(userDetails, branch_id) {
    userDetails = { ...userDetails };
    userDetails.branch_id = branch_id;
    return this.http.post(environment.serverUrl + 'getLatestOrders', userDetails, { headers: this.headers });
  }
  getOTP(obj) {

    const body = obj;

    return this.http.post(environment.serverUrl + 'getOtp', body, { headers: this.headers });
  }
  OtpVerification(obj) {


    const body = obj;

    return this.http.post(environment.serverUrl + 'otpVerification', body, { headers: this.headers });
  }
  getCurrentTime() {

    return this.http.get(environment.serverUrl + 'getCurrentTime', { headers: this.headers });
  }

  listOfRestaurants() {

    return this.http.get(environment.serverUrl + 'CreateTent', { headers: this.headers });
  }


  prepayment(obj) {

    const body = obj;

    return this.http.post(environment.serverUrl + 'prepayment', body, { headers: this.headers });
  }

  getCCAVENUEencData(obj) {

    const body = obj;

    return this.http.post(environment.serverUrl + 'getEncData', body, { headers: this.headers });
  }
  postRazorPayResponse(obj) {

    const body = obj;

    return this.http.post(environment.serverUrl + 'ccavenueResponseHandler', body, { headers: this.headers });
  }

  getOderDetails(obj, userid) {

    const body = { id: obj, userID: userid };

    return this.http.post(environment.serverUrl + 'orderSuccess', body, { headers: this.headers });
  }

  sendSqsMessage(finalOrderData, queName) {

    const body = { order: finalOrderData, quename: queName };

    return this.http.post(environment.serverUrl + 'sqsmessage', body, { headers: this.headers });
  }

  getRestaurantDetails(tenantid) {

    const body = { tentID: tenantid };

    return this.http.post(environment.serverUrl + 'restaurentID', body, { headers: this.headers });
  }
  orderByUSer(obj) {

    const body = obj;

    return this.http.post(environment.serverUrl + 'orderByUser', body, { headers: this.headers });
  }

  getOrderStatus(id) {

    const body = { orderID: id };

    return this.http.post(environment.serverUrl + 'getorderStatus', body, { headers: this.headers });
  }

  getDeliveryStatus(authToken, taskId) {

    const body = { taskId: taskId, authCode: authToken };

    return this.http.post(environment.serverUrl + 'getDeliveryStatus', body, { headers: this.headers });
  }


  getOrderDetailsByTentID(id) {

    const body = { tentid: id };

    return this.http.post(environment.serverUrl + 'orderDetailsTOresturt', body, { headers: this.headers });
  }

  getHotelsData(data) {
    return this.http.post(environment.GET_RESTAURANT_DETAILS, data);
  }

  insertAddress(data) {
    console.log("Body:::", JSON.stringify(data));
    return this.http.post(environment.serverUrl + 'insertAddress', this.addressOBJ.creteAddressOBJ(data), { headers: this.headers });
  }

  getAddress() {
    const body = {
      mobile: (localStorage.getItem('ccId')),
    };
    return this.http.post(environment.serverUrl + 'getAddress', body, { headers: this.headers });
  }

  updateAddress(data) {
    const body = {
      id: data.id,
      address: this.addressOBJ.creteAddressOBJ(data),
    };
    console.log("Body:::", JSON.stringify(body));
    return this.http.post(environment.serverUrl + 'updateAddress', body, { headers: this.headers });
  }

  deleteAddress(id) {

    console.log("ID:::", JSON.stringify(id));
    return this.http.post(environment.serverUrl + 'deleteAddress', { id: id }, { headers: this.headers });
  }

  getInactiveItems(tenant_id, branch_id, branch_code) {
    const data = {
      tenant_id: tenant_id,
      branch_id: branch_id,
      branch_code: branch_code
    };
    return this.http.post(environment.serverUrl1 + 'getInactiveItems', data, { headers: this.headers });
    // return this.http.post('http://127.0.0.1:3000/' + 'getInactiveItems', data, { headers: this.headers });

  }

  insertInactiveItems(data) {
    // return this.http.post(environment.serverUrl + 'sendInactiveItems', data, { headers: this.headers });
    return this.http.post(environment.serverUrl1 + 'inserInactiveItems', data, { headers: this.headers });

    // return this.http.post('http://127.0.0.1:3000/' + 'inserInactiveItems', data, { headers: this.headers });

  }

  findInactiveItems(tenant_id, branch_id, items) {
    let data = {
      tenant_id: tenant_id,
      branch_id: branch_id,
      items: items
    };
    return this.http.post(environment.serverUrl1 + 'findInactiveItems', data, { headers: this.headers });
    // return this.http.post('http://127.0.0.1:3000/' + 'findInactiveItems', data, { headers: this.headers });

  }

  insertInactiveBranch(data) {
    return this.http.post(environment.serverUrl + 'manageBranch', data, { headers: this.headers });
  }

  getBranchStatus(data) {
    return this.http.post(environment.serverUrl + 'getBranchStatus', data, { headers: this.headers });
  }

  noCashDynamicQR(data: any) {
    const headers = new HttpHeaders()
      .set('Access-Control-Allow-Origin', '*')
      .set('Content-Type', 'application/json')
      .set('no-cash-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZXJjaGFudElkIjoyLCJkZXZpY2VJZCI6MSwiaWF0IjoxNjk3ODc0MTkxfQ.zYj0DC6RXNTOhnvXDgqeQVNh5ldfW-ejOMjXZt8Gong');

    const body = {
      "merchantId": 1,
      "encryptedData": "4sil9Bjj1PpX+Zl6vpZwOuQT9K+qtZtqxtedF60ojB4/1PhsZIqZylQ7RYYRJH4snucRNFJ5tH1J9Jg4nQ8vU87O9nBUKJpDQ3Xcm+okLjloLc9iA+21muncvZVAkuwkPeMcjwCvDqtwXrNbUncBwyk0t2yem2uCToisjNcVPl4OMg7QlX2NxtkZXCFukWG45QRlxeUlYKhzk9IL1IqIrVjBSqUZbEkmcdg+d3Mfh6DnhUvfwibE9rBDnp7IGVVgUnRfu5T9m73CAFVxr+Szp2TtegdnJYvnKvr+7h+UaP4xFXcIip/1Ou4bKT8AvnD+DQnljMsT3F9lKlG3E/GC5j8hgjNHxkp6VFwsyGf6+WY=",
      "iv": "AQm2A4/wfCzLs6EErDp93Q=="
    };

    const url = 'https://upi.nocash.in/dynamicqr';

    return this.http.post(url, body, { headers: headers });
  }

  phonePay() {
    return this.http.get(environment.serverUrl + 'pay', {});
  }

  CNpay(obj) {
    // return this.http.post(environment.paymentUrl, obj, { headers: this.headers });
    const raw = {
      "totalPrice": 5.714285714,
      "cardType": "MC",
      "cardNo": 256358965895,
      "userEmail": "sdrf@hu.lo",
      "month": 6,
      "year": 24,
      "cvv": 895,
      "seatNo": "A/1",
      "cinema": "Mall",
      "screen": "CINEMA 2",
      "comboName": "Combo 7",
      "comboId": "35"
    };
    return this.http.post("https://cineroyal.ae/app/chefDeskpay", raw, { headers: this.headers });
    //   const myHeaders = new Headers();
    //   myHeaders.append("Content-Type", "application/json");
    //   myHeaders.append("Cookie", "AWSALB=KoQNClsc7OJ1jcVf67yazazSER7aH5a3ZzU0kPg3R0xtB2AbLwJrDwV4CPpVmxOphgCwZ9ftnv13vQIrUywogPd+sW+hlK+sIKlz5ZOCXxFWJ54Umy7jyr4eCa2Y; AWSALBCORS=KoQNClsc7OJ1jcVf67yazazSER7aH5a3ZzU0kPg3R0xtB2AbLwJrDwV4CPpVmxOphgCwZ9ftnv13vQIrUywogPd+sW+hlK+sIKlz5ZOCXxFWJ54Umy7jyr4eCa2Y");
    //   const raw = JSON.stringify({
    //     "totalPrice": 5.714285714,
    //     "cardType": "MC",
    //     "cardNo": 256358965895,
    //     "userEmail": "sdrf@hu.lo",
    //     "month": 6,
    //     "year": 24,
    //     "cvv": 895,
    //     "seatNo": "A/1",
    //     "cinema": "Mall",
    //     "screen": "CINEMA 2",
    //     "comboName": "Combo 7",
    //     "comboId": "35"
    //   });
    //   const requestOptions: any = {
    //     method: "POST",
    //     headers: myHeaders,
    //     body: raw,
    //     redirect: "follow"
    //   };

    //   fetch("https://cineroyal.ae/app/chefDeskpay", requestOptions)
    //     .then((response) => response.text())
    //     .then((result) => console.log(result))
    //     .catch((error) => console.error(error));
  }
}
